import { render, staticRenderFns } from "./Set.vue?vue&type=template&id=16a766bd&"
import script from "./Set.vue?vue&type=script&lang=js&"
export * from "./Set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports